import {GetFormattedSalesTargetData} from '@/models/SalesTargetListModel'
import {SalesTargetsColConfig} from '@/services/MockData/SalesTargets/SalesTargetsColConfig'
import {getSalesTargetCsvFile, getSalesTargetsList} from '@/services/salesTargets'
import {downloadCSVFiles, getDateWithTimeString} from '@/helpers/shadcn/utils'
import {useDataTable} from '@/hooks/useDataTable-hook'
import {useQueries} from '@tanstack/react-query'
import {useMemo} from 'react'

export const useSalesTargets = () => {
  const {setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr} = useDataTable()

  const queryParams = useMemo(() => {
    const params = new URLSearchParams()
    params.append('pageSize', 50)
    if (sortingObj?.column) {
      params.append('sortBy', sortingObj?.column)
      params.append('order', sortingObj?.direction)
    }
    if (pageIndex) {
      params.append('page', pageIndex)
    }
    if (searchArr.length > 0) {
      searchArr.forEach(searchObj => {
        params.append(searchObj.field, searchObj.value)
      })
    }
    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex, searchArr])
  const [salesTargetsResult] = useQueries({
    queries: [
      {
        queryKey: ['SALES_TARGETS', queryParams],
        queryFn: () => getSalesTargetsList(queryParams),
      },
    ],
  })
  const onDownloadBtnClick = async selectedIds => {
    const data = await getSalesTargetCsvFile(
      `ids=${selectedIds}${Object.keys(queryParams).length > 0 ? `&${queryParams}` : ''}`
    )
    const fileName = `SalesTarget_${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
  }
  const resultsData = useMemo(() => salesTargetsResult?.data || {}, [salesTargetsResult?.data])
  const salesTargetsData = useMemo(() => GetFormattedSalesTargetData(resultsData), [resultsData])

  return {
    salesTargetsColConfigData: SalesTargetsColConfig,
    salesTargetsData,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    onDownloadBtnClick,
    searchArr,
  }
}
